export default __webpack_public_path__ + "static/hectagon_thumbnail-5dfe1b924467ac7e27c09db5dcbb0c7b.png";